import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { copy } from "shared/assets";

import { DeleteModal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { dataMetaSelector, unlinkEditor } from "Venues/state";
import { IVenueUser, VENUE_ACTIONS, IVenue } from "Venues/types";
import { useClearActionMetaOnUnMount } from "Venues/utils";

const { unlink } = copy.venueEditors;

interface RemoveEditorModalProps {
  venueUser: IVenueUser;
  venue: IVenue;
  handleClose: () => void;
  onRemove?: (id: string) => void;
}

export const RemoveEditorModal: FC<RemoveEditorModalProps> = ({
  venueUser: { id, firstname, lastname },
  venue,
  handleClose,
  onRemove,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(VENUE_ACTIONS.unlinkEditor));

  useClearActionMetaOnUnMount(VENUE_ACTIONS.unlinkEditor);

  const handleUnlink = () => {
    dispatch(unlinkEditor({ venue, userId: id }));
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(addTemporaryToast({ status: IStatus.success, message: unlink.success }));

      onRemove && onRemove(id);

      handleClose();
    }
  }, [apiMeta?.status, id, onRemove, dispatch, handleClose]);

  return (
    <DeleteModal
      handleClose={handleClose}
      handleDelete={handleUnlink}
      apiMeta={apiMeta}
      name={`${firstname} ${lastname}`}
      customButtonCopy={unlink.button}
      customDeleteCopy={unlink.message}
    />
  );
};
